var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadlineContainer',{attrs:{"headline":"Publications","breadcrumbs":[{text: 'Publications'}]}}),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"container"},[_c('PublicationList',{attrs:{"portals":_vm.portals,"publication-channels":_vm.publicationChannels}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }